export default __webpack_public_path__ + "static/media/g2020-5.ce614df5.jpeg";